/**
 * reference: https://gist.github.com/celsowhite/e7d3cb6c07a0ef888ade3090e9236150
 */
export default function alertNotifications() { 
    const alert = document.querySelectorAll('.alert');
    const hiddenNotifications = JSON.parse(localStorage.getItem('hiddenNotifications')) || [];
    

    Array.from(alert).forEach((notification) => {
        // Check if the notification is in our hidden array in local storage. If not, then show it.
        const notificationName = notification.id;
        if(!hiddenNotifications.includes(notificationName)) {
            notification.style.display = 'block';
        }
    });
   
    const dismissButtons = document.querySelectorAll('.alert__close');
    Array.from(dismissButtons).forEach((button) => {   
        // Save the notification that is associated with this button.
        const notificationName = button.dataset.alert;
        const notificationElement = document.querySelector('#' + notificationName);

        // Click action on this button
        button.addEventListener('click', () => {
            // Hide the notification from the page.
            notificationElement.style.display = 'none';
            // Indicate in local storage that this notification has been hidden.
            // Get the current array of hidden notifications from local storage.
            let hiddenNotifications = JSON.parse(localStorage.getItem('hiddenNotifications')) || [];
            // Add this notification name to the array
            hiddenNotifications.push(notificationName);
            // Set local storage with the new array info.
            localStorage.setItem('hiddenNotifications', JSON.stringify(hiddenNotifications));
        });
        
    });

    

}

document.addEventListener( 'DOMContentLoaded', alertNotifications );






